//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tableOption, dicOption } from '@/option/config';
export default {
  data: function data() {
    return {
      dicOption: dicOption,
      tableOption: tableOption
    };
  },
  inject: ["main"],
  methods: {
    rowSave: function rowSave(row, done) {
      this.main.activeOption.column.push(row);
      done();
    },
    rowDel: function rowDel(row, index) {
      this.main.activeOption.column.splice(index, 1);
    },
    rowUpdate: function rowUpdate(row, index, done) {
      this.main.activeOption.column.splice(index, 1, row);
      done();
    }
  }
};